import { Box, Container, Grid, Typography, Stack } from "@mui/material";
import { CartoonCardBasic } from "components/CartoonCard";
import SectionDivider from "./SectionDivider";
import PhonePreview from "components/PhonePreview/PhonePreview";
import { WEB_APP_LINK } from "utils/constants";
import MKButton from "components/MKButton";

import splashImg from "assets/images/screens/splashscreen.webp";
import meterImg from "assets/images/screens/meter.webp";
import generateImg from "assets/images/screens/generate_fart.webp";
import aiFartImg from "assets/images/screens/ai_fart.webp";
import leaderboardImg from "assets/images/screens/splashscreen.webp";
import championshipImg from "assets/images/screens/championship.webp";
import { use } from "react";
import { useNavigate } from "react-router-dom";

function AboutApp({ id }) {
  const navigate = useNavigate();
  return (
    <Box id={id} py={10}>
      <Container>
        <SectionDivider
          title="Welcome to the Fart Revolution 💨✨"
          // subtitle="Not your average app. This one sniffs out greatness."
          withDivider
          sx={{ mb: -2 }}
        />
        {/* 🧬 Feature 1: Fart Analysis */}
        <Grid container spacing={12} alignItems="center">
          <Grid item xs={12} md={12} sx={{ mb: 4 }}>
            {/* 🌐 Platform Info */}
            <Box>
              <Typography
                variant="h4"
                color="white !important"
                align="center"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  textShadow: "2px 2px 0px black",
                }}
              >
                Available for all as a WebApp 🌍
              </Typography>
              <Typography
                variant="h6"
                align="center"
                color="white !important"
                sx={{ opacity: 0.9 }}
              >
                Android & iOS apps, coming soon — stay tuned and stay gassy!
              </Typography>

              <Box mt={4} display="flex" justifyContent="center">
                <MKButton
                  variant="contained"
                  color="primary"
                  size="large"
                  href={WEB_APP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  🚀 Launch Web App
                </MKButton>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <PhonePreview image={meterImg} />
          </Grid>
          <Grid item xs={12} md={6}>
            <CartoonCardBasic
              title={"Fart Analyzer\n🧬🔍"}
              description="Ever let one rip and thought... *was that art?* FartLab records your blast, breaks down pitch, duration, and even gives you a stink score. Welcome to science, but spicy."
              color="#279e74"
              secondaryColor="#87c88b"
              tilt
            />
          </Grid>
        </Grid>

        {/* 🤖 Feature 2: AI Fart Generator */}
        <Grid container spacing={6} alignItems="center" mt={8}>
          <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
            <CartoonCardBasic
              title={"AI Fart Factory\n🤖🎵"}
              description="You imagine it — FartLab generates it. Use our AI to whip up the most absurdly accurate digital farts. Squeaky, juicy, volcanic. Just don’t play them in meetings."
              color="#00a6ed"
              secondaryColor="#2fe1f9"
              tilt
            />
          </Grid>
          <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
            <PhonePreview image={aiFartImg} />
          </Grid>
        </Grid>

        {/* 🏆 Feature 3: Fart2Earn Championships */}
        <Grid container spacing={6} alignItems="center" mt={8}>
          <Grid item xs={12} md={6}>
            <PhonePreview image={championshipImg} />
          </Grid>
          <Grid item xs={12} md={6}>
            <CartoonCardBasic
              title={"#Fart2Earn Battles\n🏆💰"}
              description="Join weekly competitions. Upload your best fart, climb the leaderboard, and earn real $FLART tokens. Internet fame, gas glory, and maybe a golden whoopee cushion await."
              color="#ffc205"
              secondaryColor="#fcdd7e"
              tilt
              buttons={[
                {
                  label: "Check now",
                  icon: "material-symbols:trophy",
                  color: "black",
                  onClick: () => navigate("/championship"),
                },
              ]}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default AboutApp;
